import { em, math } from 'polished'
import styled from 'styled-components'

import { inputWrapper } from 'styles/mixins'
import { iconInfoW, iconInfoH } from 'styles/theme/blocks'

const iconPadding = em(10)
const iconMobileW = math(`${iconInfoW} + ${iconPadding} * 2`)
const iconMobileH = math(`${iconInfoH} + ${iconPadding} * 2`)

export const Wrapper = styled.div`
  position: relative;

  ${p => p.theme.mq.upMd} {
    ${inputWrapper};
    margin-bottom: 0;
    opacity: ${p => p.theme.blocks.blockMutedOpacity};
  }
`

export const IconBox = styled.div`
  width: ${iconMobileW};
  height: ${iconMobileH};
  padding: ${iconPadding};
  opacity: ${p => p.theme.blocks.blockMutedOpacity};

  ${p => p.theme.mq.upMd} {
    position: absolute;
    top: ${em(4)};
    left: ${math(`-${iconInfoW} - ${em(5)}`)};
    width: ${iconInfoW};
    height: ${iconInfoH};
    padding: 0;
    opacity: 1;
  }
`

export const TextBox = styled.div`
  display: none;

  ${p => p.theme.mq.upMd} {
    display: block;
  }
`

export const TooltipBox = styled.div`
  position: absolute;
  right: 0;
  bottom: ${p => p.theme.indents.inputBottomIndent};
`
